import { useMutation } from '@apollo/client'
import { graphql } from '@apollo/client/react/hoc'

import { atlasClient } from 'graphql/client'
import { atlas, graphene } from 'graphql/tags'

const batchScheduleForExport = graphene`#graphql
  mutation BatchScheduleForExport($input: BatchScheduleForExportInput!) {
    batchScheduleForExport(input: $input) {
      scheduledOrders {
        id
      }
    }
  }
`

export const withScheduleForExportMutation = graphql(batchScheduleForExport, {
  alias: 'withScheduleForExportMutation',
  props: ({ mutate }) => ({
    scheduleForExport: (selectedOrderIds) =>
      mutate({
        variables: {
          input: {
            orderIds: selectedOrderIds,
          },
        },
      }),
  }),
})

const bulkUnscheduleForExport = atlas`#graphql
  mutation BulkUnscheduleForExport($input: BulkUnscheduleForExportInput!) {
    bulkUnscheduleForExport(input: $input) {
      updatedOrderIds
    }
  }
`

export const useBulkUnscheduleForExport = () => {
  const [bulkUnscheduleForExportAction] = useMutation(bulkUnscheduleForExport, {
    client: atlasClient,
  })
  const onBulkUnscheduleForExportAction = async (orderIds) => {
    const response = await bulkUnscheduleForExportAction({
      variables: {
        input: {
          orderIds,
        },
      },
    })
    return response
  }
  return onBulkUnscheduleForExportAction
}

export const withUnscheduleForExportMutation =
  (WrappedComponent) => (props) => {
    const customProps = {
      ...props,
      unscheduleForExport: useBulkUnscheduleForExport(),
    }
    return <WrappedComponent {...customProps} />
  }
